export const tableConfig = {
  columns: [
    {
      id: "name",
      name: "Name",
    },
    {
      id: "surname",
      name: "Surname",
    },
    {
      id: "email",
      name: "E-mail",
    },
    {
      id: "departmentId",
      name: "Department",
    },
    {
      id: "registrationDate",
      name: "Registration Date",
    },
    {
      id: "control",
      name: "",
    },
  ],
};

export const ROWS_PER_PAGE = 17;

export const INITIAL_SORTING_ID = "registrationDate";

export const ASCENDING_ORDER = "asc";

export const DESCENDING_ORDER = "desc";
